import { render, staticRenderFns } from "./PagePurchaseGallery.vue?vue&type=template&id=7617b48a&"
import script from "./PagePurchaseGallery.vue?vue&type=script&lang=ts&"
export * from "./PagePurchaseGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports